(()=>{
 'use strict';
 const panels=new Map();
 function setOpen(trigger,open){
  const panel=panels.get(trigger);if(!panel)return;
  trigger.setAttribute('aria-expanded',String(open));panel.hidden=!open;
  panel.dataset.state=open?'open':'closed';
  trigger.closest('[data-replo-collapsible]').dataset.state=open?'open':'closed';
  const path=trigger.querySelector('svg[aria-label="Collapse/Expand"] path');
  if(path){if(!path.dataset.novaClosedPath)path.dataset.novaClosedPath=path.getAttribute('d');path.setAttribute('d',open?'M4 7.5h8v1H4z':path.dataset.novaClosedPath)}
 }
 function toggle(trigger){
  const open=trigger.getAttribute('aria-expanded')!=='true';
  const group=trigger.closest('[data-orientation="vertical"]:not([data-replo-collapsible])');
  if(open&&group)for(const other of panels.keys())if(other!==trigger&&other.closest('[data-orientation="vertical"]:not([data-replo-collapsible])')===group)setOpen(other,false);
  setOpen(trigger,open);
 }
 for(const root of document.querySelectorAll('[data-replo-collapsible]')){
  const trigger=root.querySelector('[role="button"][aria-controls]');
  const panel=trigger&&document.getElementById(trigger.getAttribute('aria-controls'));
  if(!trigger||!panel||!root.contains(panel))continue;
  panels.set(trigger,panel);panel.dataset.novaAccordionPanel='';
  setOpen(trigger,trigger.getAttribute('aria-expanded')==='true');
  trigger.addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();toggle(trigger)},true);
  if(trigger.tagName!=='BUTTON')trigger.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();e.stopImmediatePropagation();toggle(trigger)}},true);
 }
 let index=0;
 for(const button of document.querySelectorAll('button')){
  if(!/^show more$/i.test(button.textContent.trim()))continue;
  const list=Array.from(button.parentElement.children).find(el=>el.querySelectorAll('[data-replo-collapsible]').length>3);
  const more=list&&Array.from(list.children).find(el=>!el.matches('[data-replo-collapsible]')&&el.querySelectorAll('[data-replo-collapsible]').length>1);
  if(!more)continue;
  more.dataset.novaFaqMore='';more.hidden=true;
  if(!more.id)more.id='nova-faq-more-'+(++index);
  button.setAttribute('aria-controls',more.id);button.setAttribute('aria-expanded','false');
  button.addEventListener('click',e=>{e.preventDefault();e.stopImmediatePropagation();more.hidden=false;button.setAttribute('aria-expanded','true');button.hidden=true;button.style.display='none';const first=Array.from(more.querySelectorAll('[role="button"][aria-controls]')).find(el=>el.getClientRects().length);first?.focus({preventScroll:true})},true);
 }
 const style=document.createElement('style');style.textContent='[data-nova-accordion-panel][hidden],[data-nova-faq-more][hidden]{display:none!important}';document.head.append(style);
})();
